module.exports = __webpack_public_path__ + "static/img/sportGame3.8f1b836.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/sportGame3.png
// module id = 7nX1
// module chunks = 3